

class commonFunction {
  constructor() {
    this.map = new Map();
  }

  getPhoneNumber(obj) {
    let phoneNumber = obj.getNumber();
    let dial_code = "+" + obj.getSelectedCountryData().dialCode;
    return phoneNumber.replace(dial_code, "");
  }
}



export default new commonFunction({
  map: new Map()
});



// WEBPACK FOOTER //
// ./src/service/common-function.js